/**
 * Select component overrides.
 * Glassmorphism dropdown with blur effect.
 */

import type { Theme } from '@mui/material/styles';

const select: Theme['components'] = {
  MuiSelect: {
    defaultProps: {
      MenuProps: {
        PaperProps: {
          sx: {
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            border: '1px solid var(--glass-border)',
            borderRadius: 'var(--mui-shape-customBorderRadius-lg)',
            backgroundImage: 'var(--gradient-surface)',
          },
        },
      },
    },
    styleOverrides: {
      icon: {
        color: 'var(--mui-palette-text-secondary)',
        transition: 'transform 200ms ease',
      },
    },
  },
};

export default select;
